import { render, staticRenderFns } from "./DeleteItemModal.vue?vue&type=template&id=73df761b&scoped=true&"
import script from "./DeleteItemModal.vue?vue&type=script&lang=js&"
export * from "./DeleteItemModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteItemModal.vue?vue&type=style&index=0&id=73df761b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73df761b",
  null
  
)

export default component.exports